import { AdminAppState } from '../../state';
import { getPlaceTags } from './get-place-tags';
import { identity } from 'lodash';

export const getPlaceTagsArray = (placeKey: string) => (
  state: AdminAppState,
): string[] =>
  getPlaceTags(placeKey)(state)
    .split(/(\s+|,)/)
    .map(tag => tag.trim())
    .filter(identity);
